import { ProfilePermission, Role } from '@gm-commercial/profile-model';

import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const UserList = lazyWithReload(
  () => import('~/features/users/list/AdvisorUsersListView')
);
const UserDetails = lazyWithReload(
  () => import('~/features/users/details/UserDetailsNew')
);

const ORGANIZATIONS_USERS_ROUTES = {
  [RouteName.ORGANIZATIONS_USERS]: {
    name: RouteName.ORGANIZATIONS_USERS,
    path: [
      '/users',
      '/organizations/:organizationsId/users',
      '/organizations/:organizationsId/fleets/:fleetsId/users',
      '/organizations/:organizationsId/hubs/:hubsId/users',
      '/organizations/:organizationsId/hubs/:hubsId/fleets/:fleetsId/users',
    ],
    authorizedPerms: [ProfilePermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: UserList,
  },
  [RouteName.ORGANIZATIONS_USERS_DETAILS]: {
    name: RouteName.ORGANIZATIONS_USERS_DETAILS,
    path: [
      '/users/:usersId',
      '/organizations/:organizationsId/users/:usersId',
      '/organizations/:organizationsId/fleets/:fleetsId/users/:usersId',
      '/organizations/:organizationsId/hubs/:hubsId/users/:usersId',
      '/organizations/:organizationsId/hubs/:hubsId/fleets/:fleetsId/users/:usersId',
    ],
    authorizedPerms: [ProfilePermission.READ],
    excludedRoles: [Role.OPERATOR],
    element: UserDetails,
  },
};

export default ORGANIZATIONS_USERS_ROUTES;
